import NextImage, { ImageProps } from 'next/image';

export const imageLoader = ({ src }: { src: string }): string => {
  return src;
};

export default function Image(props: ImageProps): JSX.Element {
  return <NextImage loader={imageLoader} {...props} />;
}
